import { render, staticRenderFns } from "./CharacterCard.vue?vue&type=template&id=2bc012bc&scoped=true&"
import script from "./CharacterCard.vue?vue&type=script&lang=js&"
export * from "./CharacterCard.vue?vue&type=script&lang=js&"
import style0 from "./CharacterCard.vue?vue&type=style&index=0&id=2bc012bc&prod&lang=scss&scoped=true&"
import style1 from "./CharacterCard.vue?vue&type=style&index=1&id=2bc012bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc012bc",
  null
  
)

export default component.exports